export enum ReportChartViewTypeEnum {
  WEEK = 'WEEK',
  MONTH = 'MONTH',
}
